export const hotjarIds = {
  cashadvance: 2217288,
  kwikpay: 2243019,
  default: 2212968,
};
